module.exports = __webpack_public_path__ + "img/garland-mobile.56c0ee08.png";